import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AppLayout } from "@/components/AppLayout";
import { Card, CardContent } from "@/components/ui/card";
import { api } from "@/lib/api";
import { BookOpen, Users, ArrowRight, FileText } from "lucide-react";

export default function TeacherDashboard() {
  const [grupos, setGrupos] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/grupos");
        setGrupos(data);
      } catch (err) { console.error(err); }
    })();
  }, []);

  return (
    <AppLayout>
      <div className="max-w-6xl">
        <div className="mb-8">
          <div className="text-xs tracking-[0.2em] uppercase text-[#9F2241] mb-2">Panel del docente</div>
          <h1 className="text-3xl md:text-4xl font-semibold text-[#10312B] tracking-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Mis grupos asignados
          </h1>
          <p className="text-sm text-[#545454] mt-2">
            Seleccione un grupo para gestionar su alumnado.
          </p>
        </div>

        {grupos.length === 0 ? (
          <Card className="border-[#E5E7EB]">
            <CardContent className="p-12 text-center">
              <BookOpen className="w-10 h-10 text-[#9CA3AF] mx-auto mb-3" />
              <div className="text-[#545454]">No tiene grupos asignados. Contacte al administrador.</div>
            </CardContent>
          </Card>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {grupos.map((g) => (
              <Card key={g.id} className="border-[#E5E7EB] hover:border-[#235B4E] transition-colors h-full">
                <CardContent className="p-5">
                  <Link
                    to={`/grupos/${g.id}/alumnos`}
                    data-testid={`teacher-grupo-${g.id}`}
                    className="block group"
                  >
                    <div className="flex items-start justify-between">
                      <div>
                        <div className="text-xs uppercase tracking-wider text-[#9CA3AF] mb-1">
                          {g.plantel?.nivel}
                        </div>
                        <div className="text-3xl font-semibold text-[#10312B]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                          {g.grado}° {g.letra}
                        </div>
                        <div className="text-sm text-[#545454] mt-2">{g.plantel?.nombre}</div>
                      </div>
                      <ArrowRight className="w-5 h-5 text-[#9CA3AF] group-hover:text-[#235B4E] transition-colors" />
                    </div>
                    <div className="mt-4 pt-3 border-t border-[#E5E7EB] flex items-center gap-2 text-sm">
                      <Users className="w-4 h-4 text-[#235B4E]" />
                      <span className="text-[#374151]">{g.alumnos_count} alumnos</span>
                      <span className="ml-auto text-xs text-[#9CA3AF]">{g.ciclo}</span>
                    </div>
                  </Link>
                  <Link
                    to={`/grupos/${g.id}/boletas`}
                    data-testid={`teacher-grupo-${g.id}-boletas`}
                    className="mt-2 flex items-center justify-center gap-1.5 py-2 text-xs font-medium text-white bg-[#235B4E] rounded hover:bg-[#1D4A40] transition-colors"
                  >
                    <FileText className="w-3.5 h-3.5" /> Boletas · calificaciones
                  </Link>
                  <Link
                    to={`/grupos/${g.id}/datos-alumnos`}
                    data-testid={`teacher-grupo-${g.id}-datos`}
                    className="mt-3 flex items-center justify-center gap-1.5 py-2 text-xs font-medium text-[#235B4E] border border-[#235B4E]/30 rounded hover:bg-[#235B4E] hover:text-white transition-colors"
                  >
                    <FileText className="w-3.5 h-3.5" /> Datos de alumnos (imprimir)
                  </Link>
                  <Link
                    to={`/grupos/${g.id}/datos-estadisticos`}
                    target="_blank"
                    data-testid={`teacher-grupo-${g.id}-est`}
                    className="mt-2 flex items-center justify-center gap-1.5 py-2 text-xs font-medium text-[#0F4C81] border border-[#0F4C81]/30 rounded hover:bg-[#0F4C81] hover:text-white transition-colors"
                  >
                    <FileText className="w-3.5 h-3.5" /> Datos estadísticos del grupo
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </AppLayout>
  );
}
